import { noop } from 'lodash';
import React, { useState } from 'react';

export interface NewUserContextState {
  activePage: number;
}

export interface ContextProvider {
  state: NewUserContextState;
  setState: React.Dispatch<React.SetStateAction<NewUserContextState>>;
}

const NewUserContext = React.createContext<ContextProvider>({
  state: { activePage: 0 },
  setState: () => noop
});

export const NewUserContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [state, setState] = useState<NewUserContextState>({ activePage: 0 });

  return <NewUserContext.Provider value={{ state, setState }}>{children}</NewUserContext.Provider>;
};

export default NewUserContext;
